import {
  RecordsSearchFilterRequest,
  FilterFieldValueType,
  ExtendedAccountInfo,
  ISelectableOption,
  EvaluatedResults,
  SetupBaseRequestInfo,
} from "../../../../types";
import {
  NO_RESULTS_DEFAULT_ISelectableOption,
  AVAILABLE_BFF_TYPEAHEAD_SEARCH_EVALUATIONS,
} from "../../constants";
import {
  getRecordsBySearchFilter,
  getStoreOptionsFromDetailsAPIResponse,
} from "../../helpers";

// This function is used to evaluate the dynamic values for typeaheadConfig
export const customTypeAheadEvaluations = async (
  evalTypeAheadMethods: string[],
  typeAheadRequest: RecordsSearchFilterRequest,
): Promise<Record<string, FilterFieldValueType>> => {
  const evaluatedTypeAheadValue: Record<string, FilterFieldValueType> = {};

  for (const method of evalTypeAheadMethods) {
    switch (method) {
      case "getCNumberFromStore": {
        const result = await getCNumberFromStore(typeAheadRequest);
        evaluatedTypeAheadValue[method] = result;
        break;
      }

      default:
        evaluatedTypeAheadValue[method] = "";
        break;
    }
  }

  return evaluatedTypeAheadValue;
};

export const getCNumberFromStore = async (
  baseRequest: RecordsSearchFilterRequest | SetupBaseRequestInfo,
): Promise<string> => {
  const {
    storeId,
    enterpriseId,
    functionalArea,
    functionalUnitName,
    accountName,
  } = baseRequest;

  const request: RecordsSearchFilterRequest = {
    storeId,
    enterpriseId,
    functionalArea,
    functionalUnitName,
    accountName,
    departmentId: baseRequest.departmentId,
    url: "/v2/search/CNumCompanyMapping",
    body: {
      filters: [
        {
          field: "company_store_id",
          operator: "EQUALS",
          value: `${storeId}`,
        },
      ],
      responseFields: ["source_cnumber"],
    },
    valueField: "source_cnumber",
    labelField: ["source_cnumber"],
  };

  const { options } = await getRecordsBySearchFilter(request);

  return (options[0]?.value as string) ?? "";
};

export const iscustomTypeAheadResultsEvaluated = (
  evalTypeAheadMethods: string[],
  evaluatedResults: EvaluatedResults,
): boolean => {
  return (
    Object.keys(evaluatedResults).length > 0 &&
    evalTypeAheadMethods.every((method) => evaluatedResults[method] !== "")
  );
};

export const customTypeAheadDefaultIdentifiers = (
  defaultIdentifier: string,
  extendedAccountInfo: ExtendedAccountInfo[],
): ISelectableOption[] => {
  switch (defaultIdentifier) {
    case "defaultStores":
      return getStoreOptionsFromDetailsAPIResponse(extendedAccountInfo);

    default:
      return [NO_RESULTS_DEFAULT_ISelectableOption()];
  }
};

export const isBFFTypeAheadSearchAvailable = (
  evalTypeAheadMethods?: string[],
): boolean => {
  const hasBffEvalMethod =
    evalTypeAheadMethods?.some((evalMethod) =>
      AVAILABLE_BFF_TYPEAHEAD_SEARCH_EVALUATIONS.includes(evalMethod),
    ) ?? false;
  return hasBffEvalMethod;
};
